import {useTranslation} from 'react-i18next';
import {cn} from '@chekin/guestapp-ui-kit';

type Props = {
  onLearnMore?: () => void;
  className?: string;
};

export function FormHeader({onLearnMore, className}: Props) {
  const {t} = useTranslation();

  return (
    <div
      className={cn('flex w-full flex-col items-start gap-2 max-w-[702px]', className)}
    >
      <h2 className="text-[26px] font-medium leading-[30px] tracking-[-0.52px] font-[var(--title-font-family)] text-[var(--font-primary)] m-0">
        {t('add_details')}
      </h2>
      <p className="text-[16px] font-normal leading-[22px] text-[#6C6C6C] m-0">
        {t('add_details_description')}
        {onLearnMore && (
          <button
            type="button"
            onClick={onLearnMore}
            className="inline underline text-[var(--primary)] font-semibold bg-transparent border-0 p-0 cursor-pointer"
          >
            {t('learn_more')}
          </button>
        )}
      </p>
    </div>
  );
}
